import { BackdropContainer } from './Backdrop.styled';

const Backdrop = (props: any) => {
  return (
    <BackdropContainer>
      <div
        className={`backdrop ${props.show ? 'show' : ''}`}
        onClick={props.closeBackdrop}
      ></div>
    </BackdropContainer>
  );
};

export default Backdrop;
